var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoExpandResponsive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44329",
    "data-name": "Group 44329",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13943",
    "data-name": "Rectangle 13943",
    width: 12,
    height: 10,
    fill: "#999"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44329-2",
    "data-name": "Group 44329",
    clipPath: "url(#clip-path)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49041",
    "data-name": "Path 49041",
    d: "M12.292,182.6a2.731,2.731,0,0,1-.233.475,1.155,1.155,0,0,1-.953.446h-.07q-4.745,0-9.49,0a1.35,1.35,0,0,1-.872-.283,1.02,1.02,0,0,1,0-1.58,1.29,1.29,0,0,1,.825-.282q4.792,0,9.584,0a1.148,1.148,0,0,1,1.189.883.176.176,0,0,0,.02.037Z",
    transform: "translate(-.292 -177.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49042",
    "data-name": "Path 49042",
    d: "M12,1.218a1.332,1.332,0,0,1-.275.54,1.225,1.225,0,0,1-.834.386c-.039,0-.078,0-.117,0H1.222a1.181,1.181,0,0,1-1.1-.607A1.035,1.035,0,0,1,.77.073,1.8,1.8,0,0,1,1.252.007C4.416,0,7.581.01,10.745,0a1.2,1.2,0,0,1,1.238.9A.193.193,0,0,0,12,.937Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49043",
    "data-name": "Path 49043",
    d: "M12.113,363.8a1.238,1.238,0,0,1-.3.575,1.2,1.2,0,0,1-.8.355c-.043,0-.086,0-.129,0q-4.77,0-9.54,0a1.242,1.242,0,0,1-.99-.426,1.032,1.032,0,0,1,.525-1.645,1.692,1.692,0,0,1,.47-.069c3.176,0,6.352,0,9.528-.006a1.185,1.185,0,0,1,1.221.9.1.1,0,0,0,.017.027Z",
    transform: "translate(-.113 -354.731)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoExpandResponsive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_expand_responsive.0402e6a8e592f90acf02b1aaad91d931.svg";